export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/no-results-couch.8a0d375.png";